module.exports = __webpack_public_path__ + "media/images/pages/bg_raise-6a54ddfdd7853bc6db8f2e1e9fbf00f9.jpg";